const state = {
  taskTypeOptions: [
    {
      label: '送药',
      value: '03:送药任务',
      icon: 'icon-yao',
      bgColor: '#74C487',
    },
    {
      label: '量体温',
      value: '04:量测任务',
      icon: 'icon-wenduji',
      bgColor: '#6ABFFF',
    },
    {
      label: '量血压',
      // value: '05:量血压',
      value: '04:量测任务',
      icon: 'icon-xieya',
      bgColor: '#7C81FF',
    },
  ],
  actionTimeOptions: [
    //任务执行时间点
    {
      label: '08:00:00',
      value: '08:00',
    },
    {
      label: '08:30:00',
      value: '08:30',
    },
    {
      label: '09:00:00',
      value: '09:30',
    },
    {
      label: '10:00:00',
      value: '10:00',
    },
    {
      label: '10:30:00',
      value: '10:30',
    },
    {
      label: '11:00:00',
      value: '11:00',
    },
    {
      label: '16:00:00',
      value: '16:00',
    },
    {
      label: '16:30:00',
      value: '16:30',
    },
    {
      label: '17:00:00',
      value: '17:00',
    },
    {
      label: '17:30:00',
      value: '17:30',
    },
    {
      label: '18:00:00',
      value: '18:00',
    },
    {
      label: '22:00:00',
      value: '22:00',
    },
    {
      label: '23:00:00',
      value: '23:00',
    },
    {
      label: '23:30:00',
      value: '23:30',
    },
    {
      label: 'now',
      value: '立即执行',
    },

  ],
}

export default {
  namespaced: true,
  state,
  // mutations,
  // actions,
}
